import {AlteraSenha} from "@/controllers/altera-senha";
import {verificaRota} from "@/domain/verifica-rota";
import {limparCampo} from "@/domain/limpaCaracteresEspeciais";
import {limparApelido} from "@/domain/limpaEspacacoCaracteresEspeciais";
import VerificaForcaSenha from "@/domain/valida-senha-forte";

export default {
    methods: {
        limparCampo,
        limparApelido,
        openModalApelido() {
            this.isModalOpen = true;
        },
        fecharModal() {
            this.isModalOpen = false;
        },
        verDescOrgaoEmissor(index, value) {
            this.verDescOrgaoSelceionado[index] = value;
        },

        startAnimation() {
            this.isShaking = true;
            setTimeout(() => {
                this.isShaking = false;
            }, 1000);
        },
        formatarData(data) {
            if (data) {
                const partes = data.split('/');
                if (partes.length === 3) {
                    return `${partes[2]}-${partes[1]}-${partes[0]}`;
                }
            }
            return data;
        },
        comparaEmail() {
            this.comp_email = (this.dados.nm_email_confirmacao !== this.dados.nm_email) ? this.comp_email = true : this.comp_email = false

        },
        comparaCelular() {
            this.compo_celular = (this.nm_celular_confirmacao !== this.dados.nm_celular) ? this.compo_celular = true : this.compo_celular = false;
        },
        comparaSenha() {
            if (!this.nm_senha_nova || !this.nm_senha_verifica_nova) {
                this.comp_senha = false;
                return;
            }
            this.comp_senha = this.nm_senha_nova !== this.nm_senha_verifica_nova;
        },
        termo() {
            this.termoVisible = true;
            this.dados.bn_aceite_condicao_de_venda = true;
        },
        privacidade() {
            this.politicaVisible = true;
            this.dados.bn_politica_privacidade = true;
        },
        adesao() {
            this.adesaoVisible = true;
        },
        abrirModalAceite(tipo) {
            this.openModalAceite = true;
            this.tipoAceite = tipo;
            // Chama o método correto para garantir que os checkboxes sejam marcados ao abrir o modal
            if (tipo === 1) {
                this.termo();
            } else if (tipo === 2) {
                this.privacidade();
            }
        },
        desabilitado() {
            if (this.dadosgr.statusliberacaoonline_id == 3 || this.dadosgr.statusliberacaoonline_id == 10) {
                this.desabilitadoClass = 'cursor: no-drop';
            }
        },
        tipo() {
            var tipo = ""
            if (this.dadosgr.bn_pessoajuridica) {
                tipo = 'PsJuridica_idEdita'
                this.tipo_nmendereco = 'Endereço da Empresa'
            } else {
                tipo = 'index_idEdita'
            }
            return tipo
        },
        ehBarraEdicao() {
            return verificaRota(this.dadosgr.statusliberacaoonline_id)
        },
        mensagem(estilo, texto_msg, tempo_msg, libera_proximo, etapa) {
            window.scrollTo(0, 0);
            this.estilo = estilo;
            this.msg = texto_msg;
            this.proximo = libera_proximo;
            this.mostrar_msg = true;
            (etapa != null || etapa != "") ? sessionStorage.setItem('etapa', etapa) : sessionStorage.getItem('etapa');
            this.tempo_msg = (tempo_msg == 0 || tempo_msg == null) ? this.tempo_msg = 3000 : this.tempo_msg = tempo_msg;
            setTimeout(() => {
                this.mostrar_msg = false;
            }, this.tempo_msg);
        },
        validaPassword(senha) {
            const verifica = new VerificaForcaSenha('password-status');
            return verifica.verificaSenhaCadastro(senha);
        },

        async alterarSenha(e) {
            e.preventDefault();

            if (!this.validaPassword(this.nm_senha_nova)) {
                this.mensagem('error', 'A nova senha não atende aos requisitos.', 5000, false);
                return;
            }

            if (this.nm_senha_nova !== this.nm_senha_verifica_nova) {
                this.mensagem('error', 'As senhas não conferem.', 5000, false);
                return;
            }

            const data = {
                id: this.id_user,
                nm_senha_atual: this.nm_senha_atual,
                nm_senha: this.nm_senha_nova,
                verifica_senha: this.nm_senha_verifica_nova,
            };

            this.loading = true;
            const response = await AlteraSenha(data);
            this.loading = false;
            this.ativa_radio = 'disabled';

            if (response.erro !== 0) {
                this.mensagem('error', `${response.mensagem}`, 5000, false);
            } else {
                this.mensagem('success', `${response.mensagem}`, 5000, false);
                document.getElementById('modal-comprovante').classList.add('none');
            }
        },
    },
    mounted() {
        this.ehBarraEdicao()
    },
    created() {
        this.desabilitado()
    }
};